export const RECEIVE_DEFAULT_ROUND = 'play/RECEIVE_DEFAULT_ROUND';
export const UPDATE_PREDICTION = 'play/UPDATE_PREDICTION';
export const UPDATE_GOLDEN_GOAL = 'play/UPDATE_GOLDEN_GOAL';
export const POST_PREDICTIONS = 'play/POST_PREDICTIONS';
export const SUBMISSION_STATUS = 'play/SUBMISSION_STATUS';
export const POST_PREDICTIONS_SUCCESS = 'play/POST_PREDICTIONS_SUCCESS';
